import type { Messages } from '../messages.js'

/** Malay. No plural inflection at all, so every count uses one form. */
export const ms: Messages = {
  tag: 'ms',

  readingDictionary: 'Membaca kamus…',
  noWordList: 'Tiada senarai kata untuk "{language}". Bina satu:  pnpm dictionary build',
  emptyWordList: 'Senarai kata untuk "{language}" kosong.',

  flips: 'balikan',
  score: 'mata',
  words: 'kata',
  round: 'pusingan',
  ticksLeftLabel: 'Masa berbaki dalam pusingan ini',
  typeAWord: 'taip satu kata',
  tapPrompt: 'sentuh untuk ambil atau pulangkan, lalu {action}',

  boardOfTiles: 'Papan {n} jubin',
  faceDown: 'tertutup',
  wildCard: 'kad liar',
  wildKey: 'mana-mana huruf',
  letterReplaced: '{from} menjadi {to}',
  letterSwap: 'TUKAR HURUF!',
  spentTile: 'jubin terpakai',
  hiddenWhilePaused: 'disembunyikan semasa henti',
  letterInWord: '{letter}, huruf ke-{position} dalam kata',

  completeWord: 'Hantar kata',
  completeShort: 'Hantar',
  reset: 'Kosongkan',
  pause: 'Henti',
  resume: 'Sambung',
  newGame: 'Permainan baharu',
  paused: 'Dihentikan',
  outOfFlips: 'Balikan habis',
  finalResult: '{score} mata daripada {words} dalam {rounds}',
  playAgain: 'Main lagi',
  share: 'Kongsi',
  shareCopied: 'Disalin.',
  shareSelect: 'Salin ini:',

  lettersSelect: 'huruf memilih',
  keysWild: 'diambil apabila anda menaip huruf yang tiada pada mana-mana jubin',
  clearsEvery: 'membuang semua {letter} yang dipilih',
  undoLastLetter: 'membatalkan huruf terakhir',
  noWordsYet: 'Belum ada kata.',

  wordRejected: '{word}  {reason}',
  reasonDuplicate: 'sudah dijumpai',
  reasonTooShort: 'terlalu pendek',
  reasonNotAWord: 'bukan kata',
  reasonAllFound: 'anda sudah ada semua',
  noSuchLetterUp: 'tiada {letter} terbuka',
  nothingUp: 'tiada yang terbuka',
  letterHidden: 'sebuah huruf bersembunyi',
  shuffled: 'dikocak',
  shuffledAndBilled: 'dikocak, {flips} balikan tidak digunakan dicaj',
  tooFewLetters: 'Huruf yang tinggal terlalu sedikit',

  gameLanguage: 'bahasa',
  interfaceLanguage: 'antara muka',
  dictionarySize: '{common} biasa daripada {full} kata',
  filterLanguages: 'Cari bahasa',
  noMatches: 'Tiada hasil',

  nerdMode: 'mod terperinci',
  rules: 'Peraturan',
  difficulty: 'kesukaran',
  difficultyNames: { easy: 'mudah', medium: 'sedang', hard: 'sukar', insane: 'ganas' },
  pausedNoBoard: 'Permainan ini tidak akan masuk papan pendahulu.',
  about: 'Perihal',
  themeLabel: 'tema',
  themeNames: { traditional: 'tradisional', light: 'cerah', contrast: 'kontras tinggi' },
  tiles: 'jubin (N)',
  secondsPerTick: 'detik / denyut',
  holdTicks: 'denyut tahan',
  minWord: 'kata terpendek',
  startingFlips: 'balikan permulaan',
  wildChance: 'peluang kad liar',
  replaceChance: 'peluang tukar huruf',
  hideChance: 'peluang huruf disembunyikan',
  wordCompleteMode: 'kata selesai',
  wordCompleteNames: { shuffle: 'kocak', spend: 'guna', keep: 'simpan' },
  flipEconomy: 'ekonomi balikan',
  flipEconomyNames: {
    none: 'tiada',
    perLetter: 'per huruf',
    fibonacci: 'fibonacci',
    overMinimum: 'melebihi minimum',
  },
  repeatedLetterKey: 'kekunci huruf berulang',
  keySchemeNames: { cycle: 'kitar', advance: 'maju' },
  keySchemeHelp: {
    cycle:
      'A mengambil A bebas yang seterusnya, dan apabila semuanya dalam kata, ia membuangnya. ' +
      'Shift+A juga membuangnya.',
    advance: 'A mengambil A bebas yang seterusnya. Shift+A membuang setiap A daripada kata.',
  },

  whatThatMeans: 'Apa maksudnya',
  factRound: 'satu pusingan',
  factWholeBoardUp: 'seluruh papan terbuka',
  factRoundCosts: 'satu pusingan berharga',
  factFlipsBuy: 'balikan permulaan memberi',
  factThisBoard: 'papan ini',
  factBoardHadToAdmit: 'papan perlu membenarkan',
  ticksAndSeconds: '{ticks}, {seconds}',
  wordsLongest: '{words}, terpanjang {longest}',
  wordsIncludingOneOf: '{words} termasuk satu daripada {ceiling}',
  scorelessRounds: '{rounds} tanpa mata',

  whatAWordPays: 'Bayaran sepatah kata',
  columnLetters: 'huruf',
  columnCost: 'kos',
  columnPoints: 'mata',
  columnFlips: 'balikan',
  columnNet: 'bersih',

  canonicalRules: 'Peraturan {difficulty} yang rasmi.',
  customRules: 'Diubah daripada praset. Skor dengan peraturan sendiri tidak diberi kedudukan.',
  applyAndStart: 'Guna dan mulakan permainan baharu',
  changesNextGame: 'Perubahan berkuat kuasa pada permainan berikutnya.',
  presets: 'Praset:',

  start: 'Mula',
  restart: 'Mula semula',
  quit: 'Keluar',
  quitTitle: 'Keluar dari permainan ini?',
  restartTitle: 'Mula semula permainan ini?',
  restartConfirm: 'Mula semula',
  quitConfirm: 'Keluar',
  keepPlaying: 'Terus bermain',
  personalBest: 'Permainan terbaik anda',
  newPersonalBest: 'Rekod peribadi baharu.',
  columnRank: '#',
  notRanked: 'Peraturan sendiri, jadi permainan ini tidak diberi kedudukan.',
  notRankedPaused: 'Jam berhenti, jadi permainan ini tidak diberi kedudukan.',
  rankOfTotal: '{rank} daripada {total}',

  howToPlay: 'Cara bermain',

  backToGame: 'Kembali ke permainan',
  welcomeTitle: 'Selamat datang ke Blinkered',
  tutorialSkip: 'Langkau',
  tutorialNext: 'Seterusnya',
  tutorialBack: 'Kembali',
  tutorialStart: 'Mula bermain',
  tutorialHideAgain: 'Jangan tunjuk lagi',
  tutorialProgress: '{n} daripada {total}',
  tutorialSkipTitle: 'Langkau pengenalan?',
  tutGoalTitle: 'Blinkered ialah perlumbaan',
  tutGoalBody:
    'Anda memulakan permainan dengan bilangan balikan yang tetap, dan setiap jubin yang terbalik memakan satu balikan. Apabila balikan habis, permainan tamat. Membina perkataan memberi balikan, dan lebih panjang perkataan itu, lebih banyak balikan yang anda peroleh.',
  tutSpentBody:
    'Huruf yang anda gunakan dalam perkataan tertutup sehingga pusingan seterusnya. Hanya pertukaran huruf yang mengubah huruf yang ada di papan.',
  tutChangeTitle: 'Huruf boleh berubah',
  tutSameLetters:
    'Nampak perkataan yang tidak sempat anda mainkan? Huruf yang sama kembali pada pusingan seterusnya, dikocak ke tempat baharu.',
  tutPickLetters: 'Ketik huruf yang anda mahu mengikut urutan untuk membina perkataan.',
  tutMoreTurn:
    'Jubin terus terbalik semasa anda berfikir, jadi huruf yang lebih baik mungkin masih akan datang.',
  tutTapBack:
    'Tersalah ketik? Ketik sekali lagi untuk memulangkannya. Mana-mana huruf, bukan yang terakhir sahaja.',
  tutComplete: 'Tekan Selesai apabila perkataan sudah siap.',
  htBoardTitle: 'Papan',
  htBoardBody:
    'Jubin dibuka satu demi satu, dalam susunan rawak. Daripada jubin yang terbuka anda membina perkataan.',
  htWordsTitle: 'Perkataan',
  htWordsBody:
    'Bina perkataan daripada jubin yang terbuka dengan menaip atau mengklik hurufnya mengikut urutan.',
  htFlipsTitle: 'Balikan',
  htFlipsBody:
    'Setiap jubin yang terbalik memakan satu balikan. Perkataan yang siap menambah balikan kepada jumlah anda, dan perkataan panjang memberi lebih. Apabila balikan habis, permainan tamat.',
  htRoundTitle: 'Pusingan',
  htRoundBody:
    'Apabila jubin terakhir sesuatu pusingan terbalik, seluruh papan terbuka seketika. Kemudian jubin dibalikkan tertutup dan dikocak, dan pusingan baharu bermula.',
  htLanguagesTitle: 'Bahasa',
  htLanguagesBody:
    '{n}. Setiap papan boleh diselesaikan dengan perkataan yang benar-benar digunakan. Perkataan luar biasa tetap dikira, jika kamus mengetahuinya.',
  htKeysTitle: 'Papan kekunci',
  htWildTitle: 'Kad liar',
  htWildBody:
    'Kadangkala kad liar muncul menggantikan huruf. Kad liar berfungsi sebagai apa-apa huruf yang membentuk perkataan yang sah. Perkataan yang sudah siap tidak dikira.',
  htHideTitle: 'Huruf yang bersembunyi',
  htHideBody:
    'Pada tahap yang lebih sukar, huruf yang terbuka boleh menutup sendiri dan kembali kemudian dalam pusingan itu. Pemasa mendapat satu tik tambahan untuknya, berwarna merah. Huruf yang sudah dipilih tidak menutup.',
  tutHideBody:
    'Pada tahap yang lebih sukar, huruf yang terbuka boleh menutup sendiri dan kembali kemudian dalam pusingan itu. Huruf yang sudah dipilih tidak menutup.',
  htSwapTitle: 'Huruf yang bertukar',
  htSwapBody:
    'Kadangkala, antara pusingan, satu huruf diganti dengan huruf lain. Anda akan nampak huruf mana yang dibuang dan mana yang ditambah.',
  htLevelsTitle: 'Tahap kesukaran',
  htLevelEasy:
    'Dua belas huruf yang sama sepanjang permainan, jadi anda boleh menghafalnya dan menyimpan senarai perkataan dalam kepala. Jubin terbalik perlahan dan papan penuh kekal kelihatan cukup lama untuk anda selesai memilih huruf.',
  htLevelMedium:
    'Sekali-sekala satu huruf bertukar, jadi lebih sukar mengingati perkataan yang anda ingin mainkan kemudian. Kurang masa untuk melihat dan kurang untuk berfikir.',
  htLevelHard:
    'Perkataan tiga huruf tidak lagi dikira, dan satu huruf bertukar kira-kira setiap dua pusingan. Papan baru sahaja kelihatan sebelum ia dikocak semula.',
  htLevelInsane:
    'Semuanya serentak, pada kelajuan penuh. Papan dikocak hampir sebaik sahaja balikan terakhir selesai.',
  htTouchTitle: 'Skrin sentuh',
  htTouchBody:
    'Sentuh jubin yang terbuka untuk mengambil hurufnya. Sentuh mana-mana huruf yang diambil untuk memulangkannya. Hantar dan Kosongkan ada di bawah papan.',

  accountTitle: 'Akaun anda',
  menuProfile: 'Profil saya',
  menuGames: 'Permainan saya',
  menuPublicPage: 'Halaman awam saya',
  menuSignedInAs: 'Log masuk sebagai',
  signIn: 'Log masuk',
  signOut: 'Log keluar',
  signInTitle: 'Log masuk atau daftar',
  signInLead: 'Akaun menyimpan permainan anda, pada setiap peranti.',
  signInKeepGame: 'Log masuk untuk menyimpan permainan ini, dan semua selepasnya.',
  continueWithApple: 'Teruskan dengan Apple',
  continueWithGoogle: 'Teruskan dengan Google',
  signInOr: 'atau',
  emailLabel: 'E-mel',
  codeLabel: 'Kod',
  emailMeACode: 'Hantarkan saya kod',
  working: 'Sekejap…',
  sendNewCode: 'Hantar kod baharu',
  codeSent: 'Semak e-mel anda. Kod bertahan 10 minit.',
  notNow: 'Bukan sekarang',
  badEmail: 'Ini tidak kelihatan seperti alamat e-mel.',
  badCode: 'Kod itu tidak menjadi. Kod luput selepas 10 minit dan hanya sekali guna.',
  serverBusy: 'Tidak dapat menghubungi pelayan. Cuba lagi sebentar.',
  serverDown: 'Tidak dapat menghubungi pelayan.',
  offline: 'Luar talian',
  leaderboardTitle: 'Papan Pendahulu',
  leaderboardEmpty: 'Belum ada permainan di papan ini. Jadilah yang pertama.',
  leaderboardWouldBe: 'Di mana permainan ini akan berada',
  leaderboardThisGame: 'Permainan ini',
  leaderboardRanksHere: 'Di mana permainan ini berada',
  leaderboardOutside: 'Di luar lima teratas.',
  tutAccountTitle: 'Simpan skor anda',
  tutAccountBody:
    'Akaun menyimpan permainan anda, meletakkan skor anda di papan pendahulu, dan menjaga profil anda.',
  ssoCancelled: 'Log masuk dibatalkan.',
  ssoExpired: 'Terlalu lama. Log masuk sekali lagi.',
  ssoNoUsername: 'Akaun tidak sempat disiapkan. Cuba lagi sebentar.',
  ssoFailed: 'Tidak menjadi. Cuba lagi, atau guna e-mel anda.',
  tabProfile: 'Profil',
  countryAny: 'Tidak mahu beritahu',
  findCountry: 'Cari negara',
  usernameLabel: 'Nama pengguna',
  bioLabel: 'Tentang saya',
  countryLabel: 'Negara',
  bioHint: 'Tiada pautan. {left}/{max}',
  save: 'Simpan',
  saving: 'Menyimpan…',
  saved: 'Tersimpan.',
  nameTaken: 'Nama itu sudah diambil.',
  nameTooShort: 'Panjang sedikit lagi.',
  nameTooLong: 'Terlalu panjang.',
  nameBadCharacters: 'Huruf, angka, sempang dan garis bawah sahaja.',
  nameBadEdges: 'Mesti bermula dan berakhir dengan huruf atau angka.',
  nameMixedScripts: 'Pilih satu tulisan dan kekal dengannya.',
  nameReserved: 'Ini nampak seperti nama yang kami beri sendiri. Pilih yang lain.',
  nameUnusable: 'Nama itu tidak boleh digunakan.',
  bioTooLong: 'Ruangan ini muat {max} aksara sahaja.',
  bioHasLink: 'Pautan tidak dibenarkan di sini.',
  bioHasControl: 'Ada aksara yang tidak boleh berada di sini.',
  bioUnusable: 'Teks itu tidak boleh digunakan.',
  gamesHeading: 'Permainan',
  gamesEmpty:
    'Belum ada apa-apa di sini. Permainan yang anda main setelah log masuk akan muncul di sini.',
  gamesEmptyShort: 'Belum ada apa-apa di sini.',
  gamesLoading: 'Membaca permainan anda…',
  theirGamesLoading: 'Membaca permainan mereka…',
  profileLoading: 'Membaca profil…',
  playerNotFound: 'Tiada sesiapa di sini dengan nama itu.',
  columnWhen: 'Bila',
  columnRounds: 'pusingan',
  columnGame: 'Permainan',
  gameLoading: 'Membaca permainan…',
  gameUnreadable: 'Permainan ini tidak dapat dibaca.',
  gameNotRanked: 'Dimainkan dengan peraturan yang diubah, jadi tidak disenaraikan.',
  detailNotKept: 'Perkataan dan papan permainan ini tidak disimpan lagi.',
  openingBoard: 'Papan pembukaan',
  roundByRound: 'Pusingan demi pusingan',
  roundNothing: 'tiada apa dijumpai',
  changeReplaced: '{letter} diganti di petak {slot}',
  changeWildOn: '{letter} jadi joker di petak {slot}',
  changeWildOff: '{letter} joker hilang dari petak {slot}',
  keepThisGame: 'Simpan permainan ini',
  savedToYourGames: 'Tersimpan dalam permainan anda.',

  reportThis: 'Laporkan',
  reportHeading: 'Laporkan ini',
  reportTheName: 'Nama',
  reportTheBio: 'Bio',
  reportTheScore: 'Skor',
  reportWhy: 'Apa yang salah dengannya? Pilihan.',
  reportSend: 'Hantar laporan',
  reportSent: 'Terima kasih. Seseorang akan melihatnya.',
  reportSignIn: 'Masuk untuk melaporkan sesuatu.',
  reportGone: 'Itu sudah tiada.',
  reportCancel: 'Batal',

  deleteAccount: 'Hapus akaun saya',
  deleteAccountWhat:
    'Ini membuang profil anda dan setiap permainan yang anda simpan, selama-lamanya. Tidak boleh dibatalkan.',
  deleteAccountAsk: 'Hantar saya kod',
  deleteConfirm: 'Hapus selama-lamanya',
  deleteGone: 'Akaun anda telah hilang. Terima kasih kerana bermain.',
  deleteNoAddress:
    'Tiada alamat yang disahkan pada akaun ini, jadi penghapusan tidak dapat diperiksa. Hubungi kami dan kami akan lakukan secara manual.',

  rulesetFacts: 'Perkataan {letters} · jubin baharu setiap {seconds}',
  plurals: {
    words: { other: '{n} kata' },
    rounds: { other: '{n} pusingan' },
    flips: { other: '{n} balikan' },
    ticks: { other: '{n} denyut' },
    points: { other: '{n} mata' },
    minLetters: { other: 'minimum {n} huruf' },
    seconds: { other: '{n} detik' },
  },
}
